module.exports = __webpack_public_path__ + "img/UTEAST-2.013c95c5.jpg";